/* global modUtils */
export function deleteFormDataCookie() {
	modUtils.deleteCookie('formData');
}
